import { UseMutationOptions, useMutation } from 'react-query';

import { EmailStatusDto } from 'src/Services/API/generated';
import { authApi } from 'src/Services/API/index';

export const useCheckEmailStatus = (
  options?: UseMutationOptions<EmailStatusDto, unknown, { email: string }, unknown>
) => {
  return useMutation({
    ...options,
    mutationKey: ['check-email-status'],
    mutationFn: async ({ email }: { email: string }) => {
      const response = await authApi.authControllerCheckEmailStatus({ email });
      return response.data;
    },
  });
};
